import INVENTORY_API_BASE_URL from "../../config/api";

















import React, { useState, useEffect } from "react";
import axios from "axios";
import "./mentorcommission.css";
import Swal from "sweetalert2";

function Mentorcommission() {
  const [entries, setEntries] = useState([]);
  const [message, setMessage] = useState("");
  const [newCategory, setNewCategory] = useState("");
  const [newMinDiscount, setNewMinDiscount] = useState("");
  const [newMaxDiscount, setNewMaxDiscount] = useState("");

  const allowedCategories = [
    "Test Series",
    "ebooks",
    "Typing",
    "video courses",
    "Books",
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          `${INVENTORY_API_BASE_URL}/api/product-discounts`
        );
        if (res.data?.data) {
          setEntries(res.data.data);
        }
      } catch (err) {
        console.error("Fetch error:", err);
        setMessage("Failed to load data");
      }
    };
    fetchData();
  }, []);

  const handleChange = (index, field, value) => {
    const newEntries = [...entries];
    newEntries[index][field] = value;
    setEntries(newEntries);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const updatedEntries = [...entries];

    if (
      newCategory &&
      newMinDiscount !== "" &&
      newMaxDiscount !== "" &&
      !entries.some(
        (e) => e.category.toLowerCase() === newCategory.toLowerCase()
      )
    ) {
      updatedEntries.push({
        category: newCategory.trim().toLowerCase(),
        minDiscount: Number(newMinDiscount),
        maxDiscount: Number(newMaxDiscount),
      });
    }

    try {
      const response = await axios.put(
        `${INVENTORY_API_BASE_URL}/api/product-discounts`,
        updatedEntries,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data?.data) {
        setEntries(response.data.data);
        setNewCategory("");
        setNewMinDiscount("");
        setNewMaxDiscount("");
      }

      Swal.fire({
        icon: "success",
        title: "Success",
        text: response.data.message || "Updated successfully",
        timer: 2500,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error("❌ Frontend error:", error.response || error.message);

      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error.response?.data?.message ||
          error.message ||
          "Unknown error occurred",
        timer: 1000,
        showConfirmButton: false,
      });
    }
  };

  return (
    <div className="managecommission-container">
      <form
        onSubmit={handleSubmit}
        style={{
          maxWidth: "900px",
          margin: "30px auto",
          padding: "30px",
          background: "#ffffff",
          borderRadius: "12px",
          boxShadow: "0 8px 24px rgba(0, 0, 0, 0.08)",
          fontFamily: "Segoe UI, sans-serif",
        }}
      >
        <h2
          style={{
            textAlign: "center",
            fontWeight: 700,
            fontSize: "24px",
            marginBottom: "30px",
            color: "#333",
          }}
        >
          Mentor Commission Discount Form
        </h2>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr",
            fontWeight: "600",
            fontSize: "16px",
            borderBottom: "2px solid #ddd",
            paddingBottom: "12px",
            marginBottom: "15px",
            color: "#444",
            textAlign: "center",
          }}
        >
          <div>Product Category</div>
          <div>Student Discount (%)</div>
          <div>Mentor Commission (%)</div>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr",
            gap: "15px",
            marginBottom: "20px",
            alignItems: "center",
          }}
        >
          <select
            value={newCategory}
            onChange={(e) => setNewCategory(e.target.value)}
            style={{
              padding: "12px",
              borderRadius: "8px",
              border: "1px solid #ccc",
              textAlign: "center",
              minWidth: "100%",
              backgroundColor: "#fff",
            }}
          >
            <option value="">-- Select Category --</option>
            {allowedCategories
              .filter(
                (cat) =>
                  !entries.some(
                    (entry) =>
                      entry.category.toLowerCase() === cat.toLowerCase()
                  )
              )
              .map((cat) => (
                <option key={cat} value={cat}>
                  {cat}
                </option>
              ))}
          </select>

          <input
            type="number"
            placeholder="Student Discount"
            value={newMinDiscount}
            onChange={(e) => setNewMinDiscount(e.target.value)}
            min={0}
            max={100}
            style={{
              padding: "12px",
              borderRadius: "8px",
              border: "1px solid #ccc",
              textAlign: "center",
              minWidth: "100%",
            }}
          />

          <input
            type="number"
            placeholder="Mentor Commission"
            value={newMaxDiscount}
            onChange={(e) => setNewMaxDiscount(e.target.value)}
            min={0}
            max={100}
            style={{
              padding: "12px",
              borderRadius: "8px",
              border: "1px solid #ccc",
              textAlign: "center",
              minWidth: "100%",
            }}
          />
        </div>

        {entries.map((entry, index) => (
          <div
            key={index}
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr 1fr",
              gap: "15px",
              marginBottom: "12px",
              alignItems: "center",
            }}
          >
            <input
              type="text"
              value={entry.category}
              readOnly
              style={{
                padding: "12px",
                borderRadius: "8px",
                border: "1px solid #ccc",
                backgroundColor: "#f5f5f5",
                textAlign: "center",
                fontWeight: 500,
                minWidth: "100%",
              }}
            />
            <input
              type="number"
              value={entry.minDiscount}
              onChange={(e) =>
                handleChange(index, "minDiscount", e.target.value)
              }
              onWheel={(e) => e.target.blur()}
              min={0}
              max={100}
              required
              style={{
                padding: "12px",
                borderRadius: "8px",
                border: "1px solid #ccc",
                textAlign: "center",
                minWidth: "100%",
              }}
            />
            <input
              type="number"
              value={entry.maxDiscount}
              onChange={(e) =>
                handleChange(index, "maxDiscount", e.target.value)
              }
              onWheel={(e) => e.target.blur()}
              min={0}
              max={100}
              required
              style={{
                padding: "12px",
                borderRadius: "8px",
                border: "1px solid #ccc",
                textAlign: "center",
                minWidth: "100%",
              }}
            />
          </div>
        ))}

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "30px",
          }}
        >
          <button
            type="submit"
            style={{
              padding: "12px 36px",
              fontSize: "16px",
              borderRadius: "8px",
              border: "none",
              backgroundColor: "#007bff",
              color: "#fff",
              fontWeight: 600,
              cursor: "pointer",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              transition: "background 0.3s ease",
            }}
            onMouseOver={(e) => (e.target.style.backgroundColor = "#0056b3")}
            onMouseOut={(e) => (e.target.style.backgroundColor = "#007bff")}
          >
            Submit
          </button>
        </div>
      </form>

      {message && (
        <p style={{ textAlign: "center", color: "#555" }}>{message}</p>
      )}
    </div>
  );
}

export default Mentorcommission;
